import styled, { css } from 'styled-components'

export const ParentIconBlueHashTag = styled.div`
  margin-bottom: auto;
  padding-top: 11px;
  ${(props) => props.theme.paddingRight}: 10px;
`

const parentIconBluePencilCss = css`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ParentIconBluePencilProfile = styled.div`
  ${parentIconBluePencilCss}
  position: absolute;
  bottom: 0;
  ${({ theme }) => theme.right}: 0;

  margin: 5px 0;
  padding: 6px 0 8px;
`

export const ParentIconBluePencilSearch = styled.div`
  ${parentIconBluePencilCss};
  padding-bottom: 8px;
`
